import { Component, input } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';

import { CommunicationStatus } from '../../services/dto/communication';
import { CamTranslationCommunication } from '../../translation.service';

@Component({
  selector: 'cam-communication-status',
  templateUrl: './communication-status.component.html',
  styleUrls: ['./communication-status.component.scss'],
  imports: [FontIconComponent, TranslatePipe],
})
export class CommunicationStatusComponent {
  value = input.required<CommunicationStatus>();

  constructor() {
    CamTranslationCommunication.getInstance();
  }

  public getTranslate() {
    return `communication.status.${CommunicationStatus[
      this.value() ?? CommunicationStatus.Unknown
    ].toLocaleLowerCase()}`;
  }
}
